import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchFeeMasterDetails = createAsyncThunk(
  "feeMaster/fetchFeeMasterDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${server}/getAllFee`, {
        headers: { Authorization: `${localStorage.getItem("token")}` },
      });
      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const feeMasterSlice = createSlice({
  name: "feeMaster",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeeMasterDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchFeeMasterDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchFeeMasterDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default feeMasterSlice.reducer;
